// /Users/zachepilka/radiomonitor-frontend/src/pages/static/TermsPage.it.jsx
import React from 'react';

export default function TermsPageIt() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Termini d’uso di Radiomonitor.net</h1>
      <p>
        I presenti Termini d’uso (i “Termini”) disciplinano l’accesso e l’utilizzo del servizio Radiomonitor.net (il “Servizio”).
        Utilizzando il Servizio, accetti integralmente i Termini qui descritti.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Disposizioni generali</h2>
      <p>Radiomonitor.net è una piattaforma online per l’analisi, il monitoraggio e l’automazione delle emittenti radio su internet.</p>
      <p>L’accesso è consentito solo dopo aver letto e accettato i presenti Termini.</p>
      <p>L’amministrazione può aggiornare i Termini senza preavviso e le modifiche sono valide dalla pubblicazione sul sito.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Erogazione dei servizi</h2>
      <p>Il Servizio viene erogato in abbonamento secondo il piano tariffario scelto o tramite accordi personalizzati.</p>
      <p>I report e i dataset generati hanno finalità esclusivamente informative e analitiche e sono utilizzati a discrezione dell’utente.</p>
      <p>Radiomonitor.net non risponde di fattori esterni (interruzioni di provider, strumenti di terzi ecc.) che influenzano il funzionamento della radio.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Limitazione di responsabilità</h2>
      <p>Facciamo il possibile per garantire un funzionamento stabile, ma non assicuriamo la disponibilità continua né l’assenza di malfunzionamenti tecnici.</p>
      <p>Il Servizio non è responsabile per perdite dirette o indirette derivanti dall’uso o dall’impossibilità di utilizzare Radiomonitor.net.</p>
      <p>L’utente è responsabile della configurazione delle proprie attrezzature, dell’ambiente software e della connessione di rete.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Pagamenti e abbonamento</h2>
      <p>Le funzionalità a pagamento sono disponibili solo dopo il buon esito del pagamento del piano o del pacchetto selezionato.</p>
      <p>I pagamenti sono elaborati tramite i provider supportati, inclusi eventuali addebiti automatici quando abilitati.</p>
      <p>In caso di cessazione del Servizio, gli importi relativi al periodo in corso non sono rimborsabili salvo diversa previsione contrattuale.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Proprietà intellettuale</h2>
      <p>Tutti i contenuti, i componenti software, le banche dati e il design appartengono a Radiomonitor.net o ai relativi licenzianti.</p>
      <p>È vietato copiare, distribuire o utilizzare algoritmi e materiali statistici senza autorizzazione scritta.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Riservatezza</h2>
      <p>Il Servizio raccoglie un insieme minimo di dati tecnici (indirizzo IP, parametri di connessione, metriche di utilizzo) necessari al funzionamento.</p>
      <p>I dati personali non vengono ceduti a terzi, salvo obblighi previsti dalla normativa vigente.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Conservazione dei dati degli utenti</h2>
      <p>Se i pagamenti vengono interrotti, i dati dell’utente sono conservati per 30 giorni di calendario dal termine dell’abbonamento.</p>
      <p>Trascorso tale periodo, le informazioni possono essere eliminate senza possibilità di recupero.</p>
      <p>Per gli utenti con abbonamento continuativo superiore a un anno, la conservazione è garantita per almeno dodici mesi.</p>
      <p>Su richiesta scritta e previo pagamento aggiuntivo, il periodo di conservazione può essere esteso con condizioni concordate con il supporto.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Cessazione dell’accesso</h2>
      <p>Radiomonitor.net può sospendere o limitare l’accesso dell’utente in caso di violazione dei Termini o di norme applicabili.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contatti</h2>
      <p>
        Per domande o proposte è possibile contattare l’amministrazione del Servizio:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
